import React, { useEffect } from 'react'

import { useCountUnreadMessagesContext } from './context'

export const CountUnreadMessages = props => {
  const { classes } = props
  const { unreadMessages, setUnreadMessages } = useCountUnreadMessagesContext()

  useEffect(() => {
    return () => {
      setUnreadMessages(0)
    }
  }, [])

  return (
    <div className={classes.wrap}>
      <p className={classes.count}>{unreadMessages}</p>
    </div>
  )
}
